var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgPlusCircleBlue = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.9974 17.3333C4.39502 17.3333 0.664062 13.6023 0.664062 8.99999C0.664062 4.39761 4.39502 0.666656 8.9974 0.666656C13.5997 0.666656 17.3307 4.39761 17.3307 8.99999C17.3307 13.6023 13.5997 17.3333 8.9974 17.3333ZM8.16406 8.16666H4.83073V9.83332H8.16406V13.1667H9.83073V9.83332H13.1641V8.16666H9.83073V4.83332H8.16406V8.16666Z",
    fill: "#00AAE5"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgPlusCircleBlue, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/plus-circle-blue.400a914f.svg";
export { ForwardRef as ReactComponent };